import { combineReducers } from 'redux'
import user from './user.reducer'
import main from './main.reducer'
import constants from './constants.reducer'
import apartments from './apartments.reducer'
import misc from './misc.reducer'

const general = combineReducers({
	main,
	user,
	constants,
	apartments,
	misc
})

export default general
